import Form from "react-bootstrap/Form";
import { CardContainer } from "../common/card-container/card-container";
import { ContentPageBody } from "../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../common/content-page-header/content-page-header";
import styles from "./disclosures-container.less";

export const DisclosuresContainer = () => {
    return (
        <CardContainer>
            <div className={styles.disclosuresContainer}>
                <ContentPageHeader title={"DISCLOSURES"} />
                <ContentPageBody isMaxWidth={true}>
                    <p>
                        Customer shall implement and maintain a comprehensive information security program that contains administrative,
                        technical, and physical safeguards that are appropriate to the Customer&apos;s size and complexity, the nature and
                        scope of its activities, and the sensitivity of the information provided by ID Dataweb; and that such safeguards
                        shall include the elements set forth in in 16 CFR §314.4 and are reasonably designed to (i) in ensure the
                        security and confidentiality of the information provided by ID Dataweb, Iii) protect against any anticipated
                        threats or hazards to the security or integrity of such information, and (iii) protect against unauthorized
                        access to or use of such information that could result in substantial harm or inconvenience to any consumer.
                    </p>

                    <p>
                        Many services containing Experian information contain information from the Death Master File as issued by the
                        Social Security Administration (“DMF”); Customer certifies pursuant to Section 203 of the Bipartisan Budget Act
                        of 2013 and 15 C.F.R. § 1110.102 that, consistent with its applicable FCRA or GLB use of Experian information,
                        the Customer&apos;s use of deceased flags or other indicia within the Experian information is restricted to
                        legitimate fraud prevention or business purposes in compliance with applicable laws, rules regulations, or
                        fiduciary duty, as such business purposes are interpreted under 15 C.F.R. § 1110.102(a)(1); and certifies that
                        the Customer will not take any adverse action against any person without further investigation to verify the
                        information from the deceased flags or other indicia within the Experian information.
                    </p>
                    <p>
                        Some Services use and/or display nonpublic personal information that is governed by the privacy provisions of
                        the GLBA. Customer certifies it has the appropriate use under the GLBA as described in its contract with ID
                        Dataweb to use and/or obtain such information and Customer further certifies it will use such information
                        obtained from GLBA Services only for such use(s) listed below:
                    </p>

                    <ul>
                        <li>As necessary to effect, administer, or enforce a transaction requested or authorized by the consumer.</li>
                        <li>
                            As necessary to effect, administer, or enforce a transaction requested or authorized by the consumer by
                            verifying the identification information contained in applications.
                        </li>
                        <li>
                            To protect against or prevent actual or potential fraud, unauthorized transactions, claims or other liability.
                        </li>
                        <li>In required institutional risk control programs.</li>
                        <li>In resolving consumer disputes or inquiries.</li>
                        <li>
                            Use by persons, or their representatives, holding a legal or beneficial interest relating to the consumer.
                        </li>
                        <li>Use by persons acting in a fiduciary or representative capacity on behalf of the consumer.</li>
                        <li>In complying with federal, state, or local laws, rules, and other applicable legal requirements.</li>
                        <li>
                            To the extent specifically permitted or required under other provisions of law and in accordance with the
                            Right to Financial Privacy Act of 1978, to law enforcement agencies (including a Federal functional regulator,
                            the Secretary of Treasury, a State insurance authority, or the Federal Trade Commission), self-regulatory
                            organizations, or for an investigation on a matter related to public safety.
                        </li>
                    </ul>

                    <Form.Group controlId={"disclosure-acknowledgement-checkbox"} className={styles.acknowledgementDiv}>
                        <Form.Check automation-id={"disclosure-acknowledgment-checkbox"} type={"checkbox"} />
                        <Form.Label>By checking this box, the Customer understands and acknowledges
                            their responsibilities under the Gramm Leach Bliley Act.</Form.Label>
                    </Form.Group>
                </ContentPageBody>
            </div>
        </CardContainer>
    );
};